/* eslint-disable no-unused-vars */
import { actions } from 'store/actions/rpcActions';
import u from 'updeep';

const initialState = {
  debugToken: null,
  modelEditable: null,
};

const rpcReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.SET_DEBUG_TOKEN:
      return u({ debugToken: action.payload }, state);

    case actions.SET_MODEL_EDITABLE:
      return u({ modelEditable: action.payload }, state);

    default:
      return state;
  }
};

export { rpcReducer };